/** @format */

export const isDev = import.meta.env.MODE === "development";

// FLAG_STATES
export const CHECKERED_FLAG = 9;
export const PRE_RACE = 8;
export const POST_RACE = 4;
export const RED_FLAG = 3;
export const CAUTION_FLAG = 2;
export const GREEN_FLAG = 1;
export const FLAGS = {
  [RED_FLAG]: "Red Flag",
  [CAUTION_FLAG]: "Caution Flag",
  [GREEN_FLAG]: "Green Flag",
  [CHECKERED_FLAG]: "Checkered Flag",
  [POST_RACE]: "Checkered Flag",
} as Record<number, string>;

// RUN_TYPES
export const PLACEHOLDER = -1;
export const NON_TRACK = 0;
export const PRACTICE = 1;
export const QUALIFYING = 2;
export const RACE = 3;
export const RUN_TYPES = {
  [PLACEHOLDER]: "Placeholder",
  [NON_TRACK]: "Non-Track Event",
  [PRACTICE]: "Practice",
  [QUALIFYING]: "Qualifying",
  [RACE]: "Race",
} as Record<number, string>;

export const S_UNKNOWN = 0;
export const ACTIVE = 1;
export const PENALTY = 2;
export const OUT = 3;
export const BEHIND_THE_WALL = 6;
export const VEHICLE_LAP_STATUSES = {
  [S_UNKNOWN]: "Unknown",
  [ACTIVE]: "Active",
  [PENALTY]: "Penalty",
  [OUT]: "Out",
  [BEHIND_THE_WALL]: "Behind the Wall",
} as Record<number, string>;

// PIT_STOP_TYPES
export const FOUR_WHEEL = "FOUR_WHEEL_CHANGE";
export const TWO_WHEEL_LEFT = "TWO_WHEEL_CHANGE_LEFT";
export const TWO_WHEEL_RIGHT = "TWO_WHEEL_CHANGE_RIGHT";
export const ONE_WHEEL = "ONE_WHEEL_CHANGE";
export const OTHER = "OTHER";
export const BLANK = "";
export const PIT_STOP_TYPES = {
  [TWO_WHEEL_LEFT]: "2L",
  [TWO_WHEEL_RIGHT]: "2R",
  [ONE_WHEEL]: "1T",
  [FOUR_WHEEL]: "4T",
  [OTHER]: "OTH",
  [BLANK]: "-",
} as Record<string, string>;

// TRACK_TYPES
export const SUPER_SPEEDWAY = "ss";
export const INTERMEDIATE = "is";
export const SHORT_TRACK = "st";
export const ROAD_COURSE = "rc";
export const STREET_CIRCUIT = "sc";
export const DIRT = "d";
export const UNKNOWN = "u";

export const TRACK_TYPES = {
  [SUPER_SPEEDWAY]: "Super Speedway",
  [INTERMEDIATE]: "Intermediate",
  [SHORT_TRACK]: "Short Track",
  [ROAD_COURSE]: "Road Course",
  [STREET_CIRCUIT]: "Street Circuit",
  [DIRT]: "Dirt",
  [UNKNOWN]: "Unknown",
} as Record<string, string>;

export const LOADING_MESSAGES = [
  "Tightening lug nuts",
  "Fueling up",
  "Clearing the windshield",
  "Checking pit speed",
  "Rolling out the pace car",
  "Updating lap counter",
  "Scanning for cautions",
  "Warming up tires",
  "Adjusting suspension",
  "Measuring tire pressure",
  "Firing engines",
  "Refreshing leaderboard",
  "Resetting timing loops",
  "Mounting fresh tires",
  "Reading race control",
  "Checking flag stand",
  "Calibrating radios",
  "Polishing decals",
  "Releasing pit crew",
  "Pacing the field",
  "Stacking restarts",
  "Stacking pennies",
  "Rescoring positions",
  "Dialing in wedge",
  "Simulating race control feed",
  "Balancing aero trim",
  "Syncing timing & scoring",
  "Reviewing sector deltas",
  "Cooling brake rotors",
  "Wiping visor cam lens",
  "Rechecking torque sheets",
  "Spotting traffic ahead",
  "Setting pit box markers",
  "Sweeping marbles",
  "Verifying restart order",
  "Resetting fuel rig",
  "Calculating tire falloff",
  "Rewinding onboard footage",
  "Analyzing pit cycles",
  "Repacking wheel bearings",
  "Confirming radio channels",
  "Double-stacking strategies",
  "Securing hood pins",
  "Optimizing downforce map",
  "Modeling pit-stop windows",
  "Leveling the jack",
  "Rolling backup car out",
  "Painting pit road lines",
  "Recharging impact guns",
  "Testing caution lights",
  "Scraping rubber buildup",
  "Rechecking scoring loops",
  "Aligning laser scanners",
  "Syncing telemetry stream",
  "Cooling oil temps",
  "Finalizing setup sheet",
  "Locking in race trim",
  "Running pre-race checklist",
  "Balancing cross-weight",
  "Scanning for debris",
  "Checking splitter height",
  "Verifying lug torque",
  "Stabilizing tire blankets",
  "Cleaning pit stall",
  "Spotting the pace truck",
  "Updating sector timing",
  "Priming fuel pump",
  "Resetting pit timer",
  "Analyzing crew chatter",
  "Testing pit road speed",
  "Recalculating intervals",
  "Checking SAFER barrier cams",
  "Rolling out tire cart",
  "Assessing track temp",
  "Refreshing aerodynamic model",
  "Monitoring weather radar",
];
